import { render, staticRenderFns } from "./VEmployeeServices.vue?vue&type=template&id=ee5c8ab8&scoped=true&lang=pug"
import script from "./VEmployeeServices.vue?vue&type=script&lang=ts"
export * from "./VEmployeeServices.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeeServices.vue?vue&type=style&index=0&id=ee5c8ab8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5c8ab8",
  null
  
)

/* custom blocks */
import block0 from "./REmployeeServices.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployee%2Fviews%2FServices%2FVEmployeeServices.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports